import { Table } from 'antd'
import type { FormInstance } from 'antd'
import { CONFIG_FIELDS } from '../utils/configFields'
import { getConfigTableColumns } from './ConfigTableColumns'

interface ConfigTableProps {
  form: FormInstance
  onFormChange?: () => void
}

export function ConfigTable({ form, onFormChange }: ConfigTableProps) {
  const columns = getConfigTableColumns(form, onFormChange)

  return (
    <>
      <style>{`
				.section-row {
					background-color: var(--gray-100);
				}
				.section-row td {
					font-weight: bold;
				}
				.section-row:hover {
					background-color: var(--gray-100) !important;
				}
			`}</style>
      <Table
        columns={columns}
        dataSource={CONFIG_FIELDS}
        pagination={false}
        rowClassName={(record) => (record.isSection ? 'section-row' : '')}
        size='small'
        style={{ width: '100%' }}
      />
    </>
  )
}
